import backend from '@common/backend';
import { ITableDataQuery } from '@common/models/TableData';

const BASE = '/cgClasses';

export interface ICreateCgClass {
	name: string;
	c_g_coordinator_id?: number;
}

export const getCgClasses = async (query: ITableDataQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const getCgClass = async (id: number) => backend.get(`${BASE}/${id}`);

export const createCgClass = async (data: ICreateCgClass) => backend.post(`${BASE}`, data);

export const updateCgClass = async (id: number, data: ICreateCgClass) =>
	backend.put(`${BASE}/${id}`, data);

export const removeCgClass = async (id: number) => backend.delete(`${BASE}/${id}`);
